"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
function SidebarContent({ children, className = '', }) {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, classnames_1.default)('py-9', 'flex-grow', 'overflow-y-auto', className) }, { children: children })));
}
exports.SidebarContent = SidebarContent;
//# sourceMappingURL=SidebarContent.js.map